'use client'

import Link from 'next/link'
import { memo } from 'react'
import { useFeatureFlag } from '@dustin-web/microsite-data/src/feature-flags/client'
import {
  useAccordionScroll,
  openAccordionItem,
} from '@dustin-web/microsite-components/src/accordion-group'

import { ACCORDION_AB_TEST_FLAG } from '../../../product-page.constants'

import './product-description.scss'

type Props = {
  title: string
  description: string[]
  pathname: string
  linkText: string
}

const ITEM_VALUE = 'description'

const ProductDescription = ({ title, description, pathname, linkText }: Props) => {
  const { enabled: accordionsEnabled } = useFeatureFlag(ACCORDION_AB_TEST_FLAG)
  const { scrollToItem } = useAccordionScroll()

  const fullDescriptionLink = `${pathname}?tab=${ITEM_VALUE}&scrollToTab=true`

  const handleAccordionClick = () => {
    openAccordionItem(ITEM_VALUE)
    scrollToItem(ITEM_VALUE)
  }

  return (
    <section className="product-description">
      <h2 className="h4">{title}</h2>
      <div data-testid="product-description-list" className="list">
        <ul>
          {description.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      </div>
      {accordionsEnabled ? (
        <button
          type="button"
          className="button-stripped"
          onClick={handleAccordionClick}
          data-testid="product-description-view-all-link">
          {linkText}
        </button>
      ) : (
        <Link
          data-testid="product-description-view-all-link"
          scroll={false}
          href={fullDescriptionLink}>
          {linkText}
        </Link>
      )}
    </section>
  )
}

export default memo(ProductDescription)
